import { Stage, Layer } from 'react-konva';
import CellRect from './CellRect';
import RoomRect from './RoomRect';

export default function MapStage({
  width,
  height,
  scale,
  position,
  onWheel,
  onDragEnd,
  cells,
  rooms,
  onRoomClick,
  onRoomHover,
  onRoomHoverEnd,
  onTouchMove,
  onTouchEnd,
}) {
  return (
    <Stage
      width={width}
      height={height}
      scaleX={scale}
      scaleY={scale}
      x={position.x}
      y={position.y}
      draggable
      onWheel={onWheel}
      onDragEnd={onDragEnd}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <Layer>
        {cells.map(cell => (
          <CellRect key={cell.key} {...cell} />
        ))}
        {rooms.map(roomShape => (
          <RoomRect
            key={roomShape.key}
            {...roomShape}
            onRoomClick={onRoomClick}
            onRoomHover={onRoomHover}
            onRoomHoverEnd={onRoomHoverEnd}
          />
        ))}
      </Layer>
    </Stage>
  );
}
